module.exports = __webpack_public_path__ + "img/接口配置.1b39c4ce.svg";